document.addEventListener('click', async (event) => {
  const trigger = event.target.closest('[data-cookie-preferences]');
  if (!trigger) return;
  event.preventDefault();
  if (trigger.disabled) return;
  trigger.disabled = true;
  try {
    if (typeof privacyBanner === 'undefined' || typeof privacyBanner.showPreferences !== 'function') {
      window.location.assign('/pages/politique-de-confidentialite#cookies-traceurs');
      return;
    }
    await privacyBanner.showPreferences();
  } catch {
    window.location.assign('/pages/politique-de-confidentialite#cookies-traceurs');
  } finally {
    trigger.disabled = false;
  }
});
